module.exports = __webpack_public_path__ + "static/media/venom-profile.11096bdb.jpg";